module.exports = __webpack_public_path__ + "media/images/step-2-cc3a723e75dd33565d7205d566ee2cd1.png";